import React, { useEffect, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import AccommodationInputText from '../../accommodations/Components/AccommodationInputText';

import type { BookingContainer } from '../bookingsSlice';

interface OfficerNoteModalProps {
  show: boolean;
  onHide: () => void;
  titleText: string;
  closeText: string;
  saveText: string;
  bookingContainer: BookingContainer | null | undefined;
  bookingId: string | null;
  noteId: string | null;
  onChange: (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    bookingId: string | null,
    noteId: string | null,
  ) => void;
  onSave: (
    event: React.MouseEvent<HTMLButtonElement>,
    bookingId: string | null,
    noteId: string | null,
  ) => void;
}
const OfficerNoteModal: React.FC<OfficerNoteModalProps> = ({
  show,
  onHide,
  titleText,
  closeText,
  saveText,
  bookingContainer,
  bookingId,
  noteId,
  onChange,
  onSave,
}) => {
  const inputId = noteId ?? 'officerBookingNote';

  const inputValue = (() => {
    const b = bookingContainer?.bookingResponses?.find(
      bo => bo.id?.toLowerCase() === (bookingId ?? '').toLowerCase(),
    );
    const n = b?.officerBookingNotes?.find(
      noi => noi.id?.toLowerCase() === (noteId ?? '').toLowerCase(),
    );
    return n?.noteText ?? '';
  })();

  const [localNote, setLocalNote] = useState<string>(inputValue);

  useEffect(() => {
    if (show) {
      setLocalNote(inputValue);
    }
  }, [show, bookingId, noteId, inputValue]);

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>{titleText}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="px-24 py-24 px-lg-40">
        <AccommodationInputText
          HandleChange={e => {
            setLocalNote(e.target.value);
            onChange(e, bookingId, noteId);
          }}
          InputId={inputId}
          InputValue={localNote}
          IsTextarea
          LabelText={titleText}
          InputName="NoteText"
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          {closeText}
        </Button>
        <Button
          variant="primary"
          onClick={e => {
            onSave(e, bookingId, noteId);
          }}
        >
          {saveText}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default OfficerNoteModal;
export { OfficerNoteModal };
